import { HorizontalTankShellAvailableFeatures } from 'types/assetModel/components/horizontalTank/geckoHorizontalTank'
import { LegacyBoilerWallsAvailableFeatures } from 'types/assetModel/components/legacyBoiler/geckoLegacyBoilerWalls'
import { LegacyConeAvailableFeatures } from 'types/assetModel/components/legacyCone/geckoLegacyCone'
import { MachinedForgingAvailableFeatures } from 'types/assetModel/components/machinedForging/geckoMachinedForgingSimple'
import { LaunchTubeAvailableFeatures } from 'types/assetModel/components/missileSilo/geckoLaunchTube'
import { PipeSectionAvailableFeatures } from 'types/assetModel/components/piping/geckoPipeSection'
import { ShipDeckAvailableFeatures } from 'types/assetModel/components/ship/geckoShipDeck'
import { ShipHullAvailableFeatures } from 'types/assetModel/components/ship/geckoShipHull'
import { TankFlatRoofAvailableFeatures } from 'types/assetModel/components/verticalTank/geckoTankFlatRoof'
import { TankFloorAvailableFeatures } from 'types/assetModel/components/verticalTank/geckoTankFloor'
import { VerticalTankShellAvailableFeatures } from 'types/assetModel/components/verticalTank/geckoVerticalTankShell'
import { LegacyBoilerAvailableComponents } from 'types/assetModel/geckoLegacyBoilerAssetModel'
import { PipelineAvailableComponents } from 'types/assetModel/geckoPipelineAssetModel'
import { VerticalTankAvailableComponents } from 'types/assetModel/geckoVerticalTankAssetModel'
import {
  HorizontalTankAvailableComponents,
  MachinedForgingAvailableComponents,
  MissleSiloAvailableComponents,
  NuclearContainmentDomeAvailableComponents,
  PressureVesselAvailableComponents,
  ShipAvailableComponents,
} from 'types/entries/geckoAssetModel'

import {
  GeckoAssetModelType,
  GeckoComponentModelType,
  GeckoFeatureModelType,
} from './assetModelEnums'
import { ConeAvailableFeatures } from './components/legacyCone/geckoCone'
import { DomeAvailableFeatures } from './components/nuclearContainmentDome/geckoDome'
import { DomeWallAvailableFeatures } from './components/nuclearContainmentDome/geckoDomeWall'
import { FlatCircularFloorAvailableFeatures } from './components/nuclearContainmentDome/geckoFlatCircularFloor'
import { EllipsoidalHeadAvailableFeatures } from './components/pressureVessel/geckoEllipsoidalHead'
import { HemisphericalHeadAvailableFeatures } from './components/pressureVessel/geckoHemisphericalHead'
import { PressureVesselShellAvailableFeatures } from './components/pressureVessel/geckoPressureVesselShell'
import { TorisphericalHeadAvailableFeatures } from './components/pressureVessel/geckoTorisphericalHead'
import { VerticalTankFoundationAvailbleFeatures } from './components/verticalTank/geckoVerticalTankFoundation'

export const componentAvailableFeatures = (
  componentType: GeckoComponentModelType
): GeckoFeatureModelType[] => {
  switch (componentType) {
    case GeckoComponentModelType.VerticalTankShell:
      return VerticalTankShellAvailableFeatures
    case GeckoComponentModelType.TankFloor:
      return TankFloorAvailableFeatures
    case GeckoComponentModelType.TankFlatRoof:
      return TankFlatRoofAvailableFeatures
    case GeckoComponentModelType.HorizontalTankShell:
      return HorizontalTankShellAvailableFeatures
    case GeckoComponentModelType.LegacyCone:
      return LegacyConeAvailableFeatures
    case GeckoComponentModelType.Cone:
      return ConeAvailableFeatures
    case GeckoComponentModelType.LegacyBoilerWalls:
      return LegacyBoilerWallsAvailableFeatures
    case GeckoComponentModelType.PipeSection:
      return PipeSectionAvailableFeatures
    case GeckoComponentModelType.ShipDeck:
      return ShipDeckAvailableFeatures
    case GeckoComponentModelType.BasicShipHull:
      return ShipHullAvailableFeatures
    case GeckoComponentModelType.LaunchTube:
      return LaunchTubeAvailableFeatures
    case GeckoComponentModelType.Dome:
      return DomeAvailableFeatures
    case GeckoComponentModelType.DomeWall:
      return DomeWallAvailableFeatures
    case GeckoComponentModelType.FlatCircularFloor:
      return FlatCircularFloorAvailableFeatures
    case GeckoComponentModelType.VerticalTankFoundation:
      return VerticalTankFoundationAvailbleFeatures
    case GeckoComponentModelType.MachinedForgingSimple:
      return MachinedForgingAvailableFeatures
    case GeckoComponentModelType.PressureVesselShell:
      return PressureVesselShellAvailableFeatures
    case GeckoComponentModelType.HemisphericalHead:
      return HemisphericalHeadAvailableFeatures
    case GeckoComponentModelType.TorisphericalHead:
      return TorisphericalHeadAvailableFeatures
    case GeckoComponentModelType.EllipsoidalHead:
      return EllipsoidalHeadAvailableFeatures
  }
}

export const assetModelAvailableComponents = (
  assetType: GeckoAssetModelType
): GeckoComponentModelType[] => {
  switch (assetType) {
    case GeckoAssetModelType.VerticalTank:
      return VerticalTankAvailableComponents
    case GeckoAssetModelType.HorizontalTank:
      return HorizontalTankAvailableComponents
    case GeckoAssetModelType.LegacyBoiler:
      return LegacyBoilerAvailableComponents
    case GeckoAssetModelType.Piping:
      return PipelineAvailableComponents
    case GeckoAssetModelType.Ship:
      return ShipAvailableComponents
    case GeckoAssetModelType.MissileSilo:
      return MissleSiloAvailableComponents
    case GeckoAssetModelType.NuclearContainmentDome:
      return NuclearContainmentDomeAvailableComponents
    case GeckoAssetModelType.MachinedForging:
      return MachinedForgingAvailableComponents
    case GeckoAssetModelType.PressureVessel:
      return PressureVesselAvailableComponents
  }
}
